import {Component, OnInit} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {delay} from 'rxjs';
import {SpinnerOverlayService} from './services/spinner.service';
import {ToastrService} from 'ngx-toastr';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'bit-angular';
  loading: boolean = false;
  constructor(
    private spinner: SpinnerOverlayService,
    private swUpdate: SwUpdate,
    private notifier: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(evt => {
        if (evt.type === 'VERSION_READY') {
          this.notifier.info('A new version available, please reload the page');
        }
      });
    }
    this.listenToLoading();
  }

  listenToLoading(): void {
    this.spinner.loadingSub
      .pipe(delay(0), untilDestroyed(this))
      .subscribe(loading => {
        this.loading = loading;
      });
  }
}
